import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import isEmpty from 'lodash/isEmpty';
import { Form, Button } from 'reactstrap';
import { injectIntl } from 'react-intl';
import momentLocalizer from 'react-widgets-moment';
import { LoadingIcon } from '../components/Loading';
import Input from '../components/Input';
import RadioGroup from '../components/RadioGroup';
import { RenderDateTimePickerNew } from '../components/DateTimePicker';
import 'react-widgets/dist/css/react-widgets.css';
import { renderSelectInput } from '../components/SelectInput';
import { returnBreedListForType, returnColorList } from '../components/BreedList';

momentLocalizer();

const validate = (values) => {
  const errors = {};
  if (isEmpty(values.name)) {
    errors.name = 'Enter name';
  }
  if (!values.breed) {
    errors.breed = 'Enter breed';
  }
  if (isEmpty(values.gender)) {
    errors.gender = 'Enter gender';
  }
  if (!values.type) {
    errors.type = 'Enter type';
  }
  if (!values.color) {
    errors.color = 'Enter color';
  }
  return errors;
};

let PetForm = (props) => {
  const {
    handleSubmit,
    submitting,
    isLoading,
    isNew,
    selectedType,
    initialValues,
  } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <Field
        component={renderSelectInput}
        name="type"
        type="select"
        label="Type"
        disabled={submitting || isLoading}
        list={[
          {
            label: 'Canine',
            value: 1,
          },
          {
            label: 'Feline',
            value: 2,
          },
          {
            label: 'Other',
            value: 3,
          },
        ]}
        required
      />
      <Field
        component={Input}
        name="name"
        type="name"
        label="Name"
        disabled={submitting || isLoading}
        required
      />
      <Field
        name="gender"
        component={RadioGroup}
        label="Gender"
        required
        defaultGender={initialValues.gender}
      />
      <Field
        // if type chosen is other, then text input
        component={selectedType && selectedType.value === 3 ? Input : renderSelectInput}
        name="breed"
        type={selectedType && selectedType.value === 3 ? 'text' : 'select'}
        label="Breed"
        disabled={submitting || isLoading}
        list={selectedType && returnBreedListForType(selectedType.value)}
        required
      />
      <Field
        component={RenderDateTimePickerNew}
        name="dob"
        showTime={false}
        label="Date of birth"
        required
        initialDate={initialValues.dob ? initialValues.dob : ''}
        isNew={isNew}
      />
      <Field
        component={renderSelectInput}
        name="color"
        type="select"
        label="Color"
        disabled={submitting || isLoading}
        list={returnColorList()}
        required
      />
      <Button
        type="submit"
        color="primary"
        disabled={submitting || isLoading}
        block
        style={{ marginTop: '20px' }}
      >
        {isLoading && (
        <LoadingIcon />
        )}
          Submit
      </Button>
    </Form>
  );
};

const selector = formValueSelector('CREATE_PET');

PetForm = connect((state) => {
  const selectedType = selector(state, 'type');
  return {
    selectedType,
  };
})(PetForm);

PetForm = reduxForm({
  form: 'CREATE_PET',
  validate,
  enableReinitialize: true,
})(PetForm);

export default injectIntl(PetForm);
